"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * NWG.Commerce.Microshop - Api
 * NWG.Commerce.Microshop - Api functionality
 *
 * The version of the OpenAPI document: NWG.Commerce.Microshop - Api
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UPSInfoToJSON = exports.UPSInfoFromJSONTyped = exports.UPSInfoFromJSON = exports.instanceOfUPSInfo = void 0;
var runtime_1 = require("../runtime");
var UPSInfoText_1 = require("./UPSInfoText");
/**
 * Check if a given object implements the UPSInfo interface.
 */
function instanceOfUPSInfo(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfUPSInfo = instanceOfUPSInfo;
function UPSInfoFromJSON(json) {
    return UPSInfoFromJSONTyped(json, false);
}
exports.UPSInfoFromJSON = UPSInfoFromJSON;
function UPSInfoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'upsItems': !(0, runtime_1.exists)(json, 'upsItems') ? undefined : (json['upsItems'] === null ? null : json['upsItems'].map(UPSInfoText_1.UPSInfoTextFromJSON)),
        'upsTextColor': !(0, runtime_1.exists)(json, 'upsTextColor') ? undefined : json['upsTextColor'],
        'upsBgColor': !(0, runtime_1.exists)(json, 'upsBgColor') ? undefined : json['upsBgColor'],
    };
}
exports.UPSInfoFromJSONTyped = UPSInfoFromJSONTyped;
function UPSInfoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'upsItems': value.upsItems === undefined ? undefined : (value.upsItems === null ? null : value.upsItems.map(UPSInfoText_1.UPSInfoTextToJSON)),
        'upsTextColor': value.upsTextColor,
        'upsBgColor': value.upsBgColor,
    };
}
exports.UPSInfoToJSON = UPSInfoToJSON;
